import React, { useState, useEffect } from 'react';
import { Icon, Button, IconButton, Select, MenuItem, CircularProgress, Switch, FormGroup, FormControlLabel } from '@material-ui/core';
import { filterStyles } from './styles';
import { get, size } from 'global/lib/lodash';
import ScorecardToggle from './ScorecardToggle';
import SearchBar from 'global/components/SearchBar';
import { removeOverflowFromBody } from 'global/utils';
import useDebounce from 'global/hooks/useDebounce';
import clsx from 'clsx';

const specialchars = ['_', '*', '/', `\\`, '[', `]`, `{`, `}`, `~`, '=', '+'];

export default (props) => {
  const { selected, setFilter, buttons, changeSearch, searchString, loading, defaultFilters } = props;
  const [searchStringLocal, setSearchStringLocal] = useState('');

  const _searchStringDebounced = useDebounce(searchStringLocal, 700);
  const searchStringDebounced = size(_searchStringDebounced) >= 3 || specialchars.find((f) => _searchStringDebounced.indexOf(f) > -1) ? _searchStringDebounced : null;

  useEffect(() => {
    if (searchString !== searchStringLocal) {
      if (!searchString) {
        setSearchStringLocal('');
      } else {
        setSearchStringLocal(searchString);
      }
    }
  }, [searchString]);

  useEffect(() => {
    if (searchString !== searchStringLocal) {
      changeSearch(searchStringDebounced);
    }
  }, [searchStringDebounced]);

  const classes = filterStyles();
  const selVal = get(selected, 'value');
  const loadingIcon = loading || (searchString && searchString !== searchStringLocal);
  const isDefault = !searchString && Object.keys(defaultFilters).reduce((agg, k) => {
    if (get(selected, k) && defaultFilters[k] !== get(selected, k)) { return false }
    return agg;
  }, true);

  return (
    <div className={classes.container}>
      <ScorecardToggle {...props} />
      <div className={classes.wrapper}>
        <SearchBar
          onClear={() => {
            setSearchStringLocal('');
          }}
          SearchIcon={loadingIcon ? <CircularProgress size={24} style={{ width: 24, height: 24, marginLeft: 12 }} />
            : isDefault ? <Icon style={{ color: 'grey', width: 48, height: 48, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>search</Icon>
              : <IconButton onClick={() => { setFilter(defaultFilters); changeSearch('') }}><Icon>replay</Icon></IconButton>}
          changeSearch={setSearchStringLocal}
          searchString={searchStringLocal}
          classes={classes.searchContainer}
        />
        {buttons.map((button, i) => {
          const type = get(button, 'type', 'default');
          if (type === 'select') {
            const selectSelected = button.options.find((o) => o.val === get(selected, button.val));
            const active = get(selectSelected, 'val') !== get(defaultFilters, get(button, 'val'));
            return (
              <Select
                key={button.val}
                value={get(selectSelected, 'val')}
                variant="filled"
                defaultValue="N/A"
                className={clsx(classes.select, active ? classes.selectSelected : undefined)}
                disableUnderline
                onChange={(e) => setFilter((f) => ({ ...f, [button.val]: e.target.value }))}
                onClose={() => removeOverflowFromBody()}
              >
                {button.options.map((opt, i) => {
                  return (
                    <MenuItem key={i} value={get(opt, 'val')}>
                      {opt.text}
                    </MenuItem>
                  );
                })}
              </Select>
            );
          } else if (type === 'switch') {
            const on = !!get(props, button.val);
            return (
              <div key={button.val} className={classes.switchContainer}>
                <FormGroup row className={classes.center}>
                  <FormControlLabel
                    classes={{ root: classes.switchText }}
                    control={
                      <Switch
                        checked={on}
                        onChange={(e) => button.onChange(e.target.checked)}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        disabled={button.disabled ? button.disabled(props) : false}
                      />
                    }
                    label={get(button, ['text', on ? 'on' : 'off'], get(button, 'text'))}
                  />
                </FormGroup>
              </div>
            );
          }

          const isSelected = selVal === get(button, 'val');
          return (
            <Button
              key={i}
              className={classes.buttonMargin}
              size={'small'}
              onClick={() => setFilter((f) => ({ ...f, value: button.val }))}
              variant="contained"
              color={isSelected ? 'primary' : undefined}
              disableElevation
            >
              {button.text}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
